function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container } from '@finect/tabular-core/Container';
import { isNode } from '@finect/front-utils/isNode';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { withTheme } from 'styled-components';
import { H1 } from '@finect/tabular-core/Headings';
import { MainContent } from '@finect/tabular-core/MainContent';
import { Redirect } from '@finect/front-core/Routes';
import { NotFound } from '@finect/tabular-components/NotFound';
import { Head } from '@finect/tabular-components/Head';
import { DatalayerScene } from '@finect/front-gtm';
import { getProductTypeBySlug } from '@finect/front-resources/Products';
import { CategoriesTabs } from '@finect/tabular-components/Products';
import { getMacrocategories, getCategories } from '../commons/store/fund/actions';
import { getCategoriesCanonical } from '../commons/IIC/utils/canonicals';
import { getCategoriesPath } from '../commons/IIC/utils/paths';
import { FamilyInsideNavigation } from '../commons/IIC/components';
import { Description } from './partials';
import { parseMacrocategoryTemplate } from './utils';
const mapStateToProps = state => ({
  categories: state.fund.categories,
  macrocategories: state.fund.macrocategories
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getMacrocategories,
    getCategories
  }, dispatch)
});
class Categories extends React.Component {
  static loadInitialData(store, cookie, match) {
    return Promise.all([store.dispatch(getCategories(getProductTypeBySlug(match.params.typeSlug))), store.dispatch(getMacrocategories())]);
  }
  componentDidMount() {
    const {
      typeSlug
    } = this.props.match.params;
    const productType = getProductTypeBySlug(typeSlug);
    if (!this.props.categories.length) this.props.actions.getCategories(productType);
    if (!this.props.macrocategories.length) this.props.actions.getMacrocategories();
  }
  render() {
    const {
      typeSlug,
      tab = ''
    } = this.props.match.params;
    const productType = getProductTypeBySlug(typeSlug);
    if (isNode() && !tab) {
      return React.createElement(Redirect, _extends({}, this.props, {
        status: 301,
        to: getCategoriesPath(productType, 'todos')
      }));
    }
    const activeTab = this.props.macrocategories.find(item => item.name === tab);
    if (!activeTab) {
      return React.createElement(NotFound, this.props);
    }
    const parsedTemplate = parseMacrocategoryTemplate(activeTab, productType);
    return React.createElement(React.Fragment, null, React.createElement(Head, {
      title: parsedTemplate.title,
      description: parsedTemplate.description,
      canonical: getCategoriesCanonical(productType, activeTab ? activeTab.name : null)
    }), React.createElement(DatalayerScene, {
      pageType: "home",
      pageId: "categories"
    }), React.createElement(Container, null, React.createElement(FamilyInsideNavigation, {
      productType: productType,
      current: "categories"
    })), React.createElement(Container, null, React.createElement(ContainerInner, null, React.createElement(MainContent, {
      fullWidth: true
    }, React.createElement("header", null, React.createElement(H1, {
      large: true
    }, parsedTemplate.title), React.createElement(Description, {
      style: {
        minHeight: '80px'
      }
    }, parsedTemplate.description)), React.createElement(CategoriesTabs, {
      productType: productType,
      macrocategories: this.props.macrocategories,
      categories: this.props.categories,
      commonProps: {
        commonPath: typeSlug,
        categoryPath: tab
      }
    })))));
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(Categories));